'use strict';

import React, {
  useState,
  useEffect,
  Fragment,
  useCallback,
  useRef
} from 'react';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import {
  createCampaign,
  createManualCampaign,
  deleteNotificationCampaign,
  getCampaignById,
  getCampaigns,
  getSegments,
  updateCampaign,
  uploadFile,
  fetchStores,
  getCampaignSummaryById
} from 'utils/network/ServiceHelper';
import Notification from 'components/Notification';
import { Transition, Switch, Listbox } from '@headlessui/react';
import DatePicker from 'react-datepicker';
import Autocomplete from 'components/Autocomplete';
import { useNavigate } from 'react-router';
import CampaignDetail from 'components/CampaignDetail';
import {
  Autocomplete as AutoCompleteMui,
  Checkbox,
  TextField,
  Tooltip
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button } from '@mui/material';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CancelScheduleSendSharpIcon from '@mui/icons-material/CancelScheduleSendSharp';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import Loading from 'components/Loading';
import MultiSelect from 'components/MultiSelect';
import {
  INDEX_FIRST_STRING,
  INDEX_LAST_STRING_200,
  INDEX_LAST_STRING_65,
  STATUS_NULL,
  PAGINATION,
  SHOW_ALL_LIMIT,
  STATUS_SUCCESS,
  STATUS_UNAUTHORIZED
} from 'utils/constants';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const DEVICE_TYPE = ['android', 'ios'];

const PLATFORM_SOURCE = [
  { label: 'Eraspace', value: 'eraspace', selected: false },
  { label: 'iBox', value: 'ibox', selected: false },
  { label: 'JDSports', value: 'jdsport', selected: false },
  { label: 'Erafone', value: 'erafone', selected: false }
];

const BASEURL = process.env.REACT_APP_BASE_URL;

export default function Campaign() {
  const navigate = useNavigate();
  const columns = [
    {
      name: 'Campaign ID',
      sortable: true,
      selector: 'id',
      cell: function render(row) {
        return <>{row.id}</>;
      }
    },
    {
      name: 'Name',
      sortable: true,
      selector: 'name',
      cell: function render(row) {
        return <>{row.name}</>;
      }
    },
    {
      name: 'Source',
      cell: function render(row) {
        return <>{row.source.join(', ')}</>;
      }
    },
    {
      name: 'Notification',
      cell: function render(row) {
        return (
          <>
            {row.is_notification ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 text-green-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 text-red-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            )}
          </>
        );
      }
    },
    {
      name: 'Status',
      selector: 'status',
      cell: function render(row) {
        return <>{row.status}</>;
      }
    },
    {
      name: 'Executed',
      cell: function render(row) {
        return (
          <>
            {row.is_execute ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 text-green-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 text-red-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            )}
          </>
        );
      }
    },
    {
      name: 'Geofence',
      cell: function render(row) {
        return (
          <>
            {row.is_geofence ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 text-green-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 text-red-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            )}
          </>
        );
      }
    },
    {
      name: 'Valid From',
      sortable: true,
      selector: 'valid_from',
      cell: function render(row) {
        return <>{moment(row.valid_from).format('DD MMMM YYYY HH:mm')}</>;
      }
    },
    {
      name: 'Valid To',
      sortable: true,
      selector: 'valid_to',
      cell: function render(row) {
        return <>{moment(row.valid_to).format('DD MMMM YYYY HH:mm')}</>;
      }
    },
    {
      name: 'Actions',
      cell: function render(row) {
        return (
          <div className="w-full flex gap-2">
            {!row.is_execute ? (
              <button
                className="p-1 text-center bg-gray-100 border rounded-lg leading-5 transition-colors duration-150 active:bg-purple-600 hover:bg-gray-300 focus:outline-none focus:shadow-outline-gray"
                onClick={() => handleCreateEdit(row)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </button>
            ) : null}
            {/* <Tooltip title="Delete Campaign" placement="top">
              <button
                className="p-1 text-center bg-gray-100 border rounded-lg leading-5 transition-colors duration-150 active:bg-purple-600 hover:bg-gray-300 focus:outline-none focus:shadow-outline-gray"
                onClick={() => handleDelete(row)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </button>
            </Tooltip> */}
            <Tooltip title="Detail" placement="top">
              <button
                className="p-1 text-center bg-gray-100 border rounded-lg leading-5 transition-colors duration-150 active:bg-purple-600 hover:bg-gray-300 focus:outline-none focus:shadow-outline-gray"
                onClick={() => handleShowCampaignSummary(row)}
              >
                <VisibilityIcon fontSize="small" />
              </button>
            </Tooltip>
            {!row.is_inbox_deleted && (
              <Tooltip title="Delete Notification" placement="top">
                <button
                  className="p-1 text-center bg-gray-100 border rounded-lg leading-5 transition-colors duration-150 active:bg-purple-600 hover:bg-gray-300 focus:outline-none focus:shadow-outline-gray"
                  onClick={() => handleShowDeleteNotification(row)}
                >
                  <CancelScheduleSendSharpIcon fontSize="small" />
                </button>
              </Tooltip>
            )}
          </div>
        );
      }
    }
  ];

  const [segments, setSegments] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [detailSummary, setDetailSummary] = useState({});
  const [source, setSource] = useState('');
  const [pagination, setPagination] = useState({
    page: PAGINATION.DEFAULT_PAGE,
    perPage: PAGINATION.DEFAULT_PER_PAGE,
    totalPage: PAGINATION.DEFAULT_TOTAL_PAGE,
    totalData: PAGINATION.DEFAULT_TOTAL_DATA
  });
  const [notification, setNotification] = useState({
    show: false,
    error: false,
    title: '',
    message: ''
  });
  const [form, setForm] = useState({
    id: null,
    segment_id: null,
    segment: null,
    name: '',
    is_notification: true,
    title: '',
    description: '',
    image: null,
    banner: null,
    image_url: '',
    banner_image_url: '',
    video_url: '',
    deeplink: '',
    valid_from: new Date(),
    valid_to: new Date(),
    schedule_at: [],
    is_bulk: false,
    store: [],
    source: []
  });
  const [createEdit, setCreateEdit] = useState(false);
  // const [showDelete, setShowDelete] = useState(false);
  const [showDeleteNotification, setShowDeleteNotification] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [sortProp, setSortProp] = useState({
    order: 'created_at',
    sort: 'desc'
  });
  const [formManual, setFormManual] = useState({
    target_name: '',
    target_email: '',
    target_device_type: 'android',
    target_fcm_token: '',
    campaign_title: '',
    campaign_description: '',
    campaign_content: '',
    campaign_image_url: '',
    campaign_banner_image_url: '',
    image: null,
    banner: null,
    campaign_video_url: '',
    campaign_deeplink: ''
  });
  const [showManual, setShowManual] = useState(false);
  const [isFile, setIsFile] = useState(false);
  const [isBannerFile, setIsBannerFile] = useState(false);
  const [stores, setStores] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [loading, setLoading] = useState(false);

  async function fetchSegmentList() {
    const body = {
      limit: -1,
      offset: 1,
      keyword: '',
      order: sortProp.order,
      sort: sortProp.sort,
      source: form.source.map((item) => item.value).join(',')
    };

    const baseUrl = process.env.REACT_APP_BASE_URL;

    try {
      const res = await getSegments(baseUrl, body);

      if (res?.status === STATUS_SUCCESS) {
        setSegments(res?.data ?? []);
      }

      if (res?.data === STATUS_NULL) {
        notif('Error', res?.error_message, true);
      }
    } catch (error) {
      return;
    }
  }

  async function fetchCampaignList(page, perPage) {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const body = {
      limit: perPage || pagination.perPage,
      offset: page || pagination.page,
      keyword: '',
      status: '',
      order: sortProp.order,
      sort: sortProp.sort,
      source
    };

    try {
      const res = await getCampaigns(baseUrl, body);
      setIsLoading(false);

      if (res?.status === STATUS_SUCCESS) {
        setCampaigns(res?.data ?? []);
        setPagination({
          ...pagination,
          totalData: res.total_data
        });
        return;
      }

      if (res?.data === STATUS_NULL) {
        notif('Error', res?.error_message, true);
        return;
      }

      if (res?.status === STATUS_UNAUTHORIZED) {
        localStorage.clear();
        navigate('/login', { replace: true });
        return;
      }

      const error = JSON.parse(await res.text());
      if (error) {
        notif('Error', error.message, true);
        return;
      }

      notif('Error', 'Network error. Please try again later!', true);
    } catch (error) {
      setIsLoading(false);
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  async function fetchStoreList(like) {
    let paramLike = like || '';
    const baseUrl = process.env.REACT_APP_STORE_URL;
    const params = `limit=${SHOW_ALL_LIMIT}&offset=1&order=updated_at&sort=DESC&like=${paramLike}`;

    try {
      const res = await fetchStores(baseUrl, params);
      setIsLoading(false);
      if (res?.status === STATUS_SUCCESS) {
        const { data } = res;
        setStores(data?.items);
        return;
      }

      if (res?.status === STATUS_UNAUTHORIZED) {
        localStorage.clear();
        navigate('/login', { replace: true });
        return;
      }

      const error = JSON.parse(await res.text());
      if (error) {
        notif('Error', error.message, true);
        return;
      }

      notif('Error', 'Network error. Please try again later!', true);
    } catch (error) {
      setIsLoading(false);
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  useEffect(() => {
    fetchSegmentList();
    fetchCampaignList();
    fetchStoreList();
  }, [source, form.source]);

  const handleCreateEdit = async (row) => {
    if (row) {
      let isExecute = false;

      try {
        const baseUrl = process.env.REACT_APP_BASE_URL;
        const res = await getCampaignById(baseUrl, row.id);

        if (res?.status === STATUS_SUCCESS) {
          isExecute = res.data.is_execute;
        }
      } catch (e) {
        /* handle error */
        return;
      }

      if (isExecute) {
        notif('Error', "Campaign already executed and can't be edited!", true);
        fetchCampaignList();

        return;
      }

      const source = [];
      row.source.forEach((x) => {
        PLATFORM_SOURCE.forEach((v) => {
          if (v.value === x) {
            source.push({
              ...v,
              selected: true
            });
          }
        });
      });

      setForm({
        ...form,
        id: row.id,
        name: row.name,
        title: row.title,
        is_notification: row.is_notification,
        description: row.description,
        image_url: row.image_url,
        banner_image_url: row.image_url,
        video_url: row.video_url,
        is_bulk: row.is_bulk,
        deeplink: row.deeplink,
        link: row.link,
        valid_from: new Date(row.valid_from),
        valid_to: new Date(row.valid_to),
        store: row.store || [],
        source: source || []
      });
    }

    setCreateEdit(true);
  };

  function handleManualCampaign() {
    setShowManual(true);
  }

  function closeCreateEdit() {
    setCreateEdit(false);
  }

  // const handleDelete = (row) => {
  //   if (row) {
  //     setForm({
  //       ...form,
  //       id: row.id
  //     });
  //   }

  //   setShowDelete(true);
  // };

  const handleShowDeleteNotification = (row) => {
    if (row) {
      setForm({
        ...form,
        id: row.id
      });
    }

    setShowDeleteNotification(true);
  };

  const handleShowCampaignSummary = async (data) => {
    setShowDetail(true);
    setForm({
      ...form,
      id: data.id
    });

    try {
      const res = await getCampaignSummaryById(BASEURL, data.id);

      if (res?.status === STATUS_SUCCESS) {
        if (!res?.data) {
          return notif('Error', res?.message, true);
        }

        setDetailSummary(res?.data);
      } else {
        const err = JSON.parse(await res.text());
        if (err) {
          notif('Error', err.message, true);
        }
      }
    } catch (err) {
      notif('Error', 'Network error. Please try again later!', true);
    }
  };

  function closeDetailCampaignSummary() {
    setForm({
      ...form,
      id: null
    });
    setDetailSummary({});
    setShowDetail(false);
  }

  function closeNotification() {
    setNotification({
      ...notif,
      show: false
    });
  }

  const handleChangeForm = (e) => {
    if (e.target.name === 'image') {
      let file, img;
      if ((file = e.target.files[0])) {
        img = new Image();
        let objectUrl = URL.createObjectURL(file);
        img.onload = function () {
          if (this.width === this.height) {
            // image aspect ration 1:1
            setForm({
              ...form,
              image: e.target.files[0]
            });
          } else {
            notif('Error', 'Please select image with aspect ratio 1 : 1', true);
            e.target.value = null;
          }
        };
        img.src = objectUrl;
      }

      return;
    }

    if (e.target.name === 'banner') {
      let file, img;
      if ((file = e.target.files[0])) {
        img = new Image();
        let objectUrl = URL.createObjectURL(file);
        img.onload = function () {
          if (this.width === this.height * 3) {
            // image aspect ration 1:1
            setForm({
              ...form,
              banner: e.target.files[0]
            });
          } else {
            notif(
              'Error',
              `Please select image with aspect ratio 3 : 1 ${this.width} ${this.height}`,
              true
            );
            e.target.value = null;
          }
        };
        img.src = objectUrl;
      }

      return;
    }

    if (e.target.name === 'title') {
      // maximum content length for title is 65
      setForm({
        ...form,
        title: e.target.value.slice(0, 65)
      });
      return;
    }

    if (e.target.name === 'description') {
      setForm({
        ...form,
        description: e.target.value.slice(0, 125)
      });
      return;
    }

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleChangeFormManual = (e) => {
    if (e.target.name === 'image') {
      let file, img;
      if ((file = e.target.files[0])) {
        img = new Image();
        let objectUrl = URL.createObjectURL(file);
        img.onload = function () {
          if (this.width === this.height) {
            setFormManual({
              ...formManual,
              image: e.target.files[0]
            });
          } else {
            notif('Error', 'Please select image with aspect ratio 1 : 1', true);
            e.target.value = null;
          }
        };
        img.src = objectUrl;
      }

      return;
    }

    if (e.target.name === 'banner') {
      let file, img;
      if ((file = e.target.files[0])) {
        img = new Image();
        let objectUrl = URL.createObjectURL(file);
        img.onload = function () {
          // ini memeriksa apakah gambar tersebut memiliki rasio aspek 2:1, yang berarti lebarnya dua kali lebih besar dari tingginya
          if (this.width === this.height * 2) {
            setFormManual({
              ...formManual,
              banner: e.target.files[0]
            });
          } else {
            notif('Error', 'Please select image with aspect ratio 2 : 1', true);
            e.target.value = null;
          }
        };
        img.src = objectUrl;
      }

      return;
    }

    if (e.target.name === 'campaign_title') {
      setFormManual({
        ...formManual,
        campaign_title: e.target.value.slice(
          INDEX_FIRST_STRING,
          INDEX_LAST_STRING_65
        )
      });
      return;
    }
    if (e.target.name === 'campaign_content') {
      setFormManual({
        ...formManual,
        campaign_content: e.target.value.slice(
          INDEX_FIRST_STRING,
          INDEX_LAST_STRING_200
        )
      });
      return;
    }
    setFormManual({
      ...formManual,
      [e.target.name]: e.target.value
    });
  };

  function handleDeviceTypeChange(value) {
    setFormManual({
      ...formManual,
      target_device_type: value
    });
  }

  const handleDateChange = (name) => (date) => {
    setForm({
      ...form,
      [name]: date
    });
  };

  const handleChangeMuiAutoComplete = (_, value) => {
    let isSelectAll = false;
    let store = [];

    value.forEach((el) => {
      if (el === 'Select All') {
        isSelectAll = true;
      }
    });

    if (isSelectAll) {
      stores.forEach((el) => {
        store.push(el);
      });

      setForm({
        ...form,
        store
      });
      return;
    }
    stores.forEach((el) => {
      value.forEach((elv) => {
        if (`${el.name}-${el.id}-${el.bu_code}` === elv) {
          store.push(el);
        }
      });
    });

    setForm({
      ...form,
      store
    });
  };

  const handleSort = useCallback((column, sortDirection) => {
    setSortProp({
      order: column.selector,
      sort: sortDirection
    });
  });

  function handleChangeNotification(value) {
    setForm({ ...form, is_notification: value });
  }

  function handleChangeBulk(value) {
    setForm({ ...form, is_bulk: value });
  }

  function handleChangeIsFile(value) {
    setIsFile(value);
  }

  function handleChangeIsBannerFile(value) {
    setIsBannerFile(value);
  }

  function closeManual() {
    setShowManual(false);
  }

  let timeout;
  useEffect(() => {
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      if (!isLoading) {
        setIsLoading(true);
        fetchCampaignList();
      }
    }, 500);
  }, [sortProp]);

  function notif(title, message, isError = false, duration = 3000) {
    setNotification({
      show: true,
      title: title,
      message: message,
      error: isError
    });

    setTimeout(() => {
      setNotification({ ...notification, show: false });
    }, duration);
  }

  function handlePerRowsChange(newPerPage, page) {
    setPagination({
      ...pagination,
      page,
      perPage: newPerPage,
      totalPage: Math.ceil(campaigns / newPerPage)
    });

    fetchCampaignList(page, newPerPage);
  }

  function handlePageChange(page) {
    setPagination({
      ...pagination,
      page
    });

    fetchCampaignList(page);
  }

  useEffect(() => {
    if (!createEdit /* && !showDelete */) {
      setForm({
        ...form,
        id: null,
        segment_id: null,
        segment: null,
        name: '',
        title: '',
        is_notification: true,
        description: '',
        image: null,
        image_url: '',
        banner: null,
        banner_image_url: '',
        video_url: '',
        deeplink: '',
        valid_from: new Date(),
        valid_to: new Date(),
        schedule_at: [],
        is_bulk: false,
        store: [],
        link: '',
        source: []
      });
      setIsSelectAll(false);
    }
  }, [createEdit /* , showDelete */]);

  useEffect(() => {
    setFormManual({
      target_name: '',
      target_email: '',
      target_device_type: 'android',
      target_fcm_token: '',
      campaign_title: '',
      campaign_description: '',
      campaign_content: '',
      campaign_image_url: '',
      campaign_banner_image_url: '',
      image: null,
      banner: null,
      campaign_video_url: '',
      campaign_deeplink: ''
    });
  }, [showManual]);

  function isValid() {
    if (form.id) {
      return (
        form.name?.length > 0 &&
        form.title?.length > 0 &&
        form.deeplink?.length > 0 &&
        form.link?.length > 0
      );
    }
    if (form.is_bulk) {
      return (
        form.name?.length > 0 &&
        form.title?.length > 0 &&
        form.deeplink?.length > 0 &&
        form.link?.length > 0
      );
    }

    return (
      form.segment !== null &&
      form.name?.length > 0 &&
      form.title?.length > 0 &&
      form.deeplink?.length > 0 &&
      form.link?.length > 0
    );
  }

  async function handleCreateEditCampaign() {
    if (!isValid()) {
      notif('Error', 'Please fill all required field', true);
      return;
    }

    if (loading) return;

    setLoading(true);

    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;

      if (form.id) {
        // handle edit campaign
        // form.segment_id = form.segment.id;

        // if image exist
        let bannerImageUrl = '';

        form.source = form.source.map((x) => x.value);

        if (form.banner) {
          const request = new FormData();
          request.append('file', form.banner, form.banner.name);
          const res = await uploadFile(baseUrl, request, 'image');
          if (res?.status === STATUS_SUCCESS) {
            const { data } = res;
            bannerImageUrl = data.url;
          }
        }

        if (bannerImageUrl?.length > 0) form.banner_image_url = bannerImageUrl;

        if (isSelectAll) {
          let tmpStore = [];
          stores.forEach((el) => {
            tmpStore.push(el);
          });
          form.store = tmpStore;
        }

        const res = await updateCampaign(baseUrl, form);
        setLoading(false);

        if (res?.status === STATUS_SUCCESS) {
          notif('Success', 'Campaign successfully updated!');

          closeCreateEdit();

          setIsLoading(true);
          fetchCampaignList();
          return;
        }

        if (isSelectAll) {
          setForm({
            ...form,
            store: []
          });
        }

        // form.schedule_at = tmpSchedules.slice(0);

        if (res?.status === STATUS_UNAUTHORIZED) {
          localStorage.clear();
          navigate('/login', { replace: true });
          return;
        }

        const err = JSON.parse(await res.text());
        if (err) {
          notif('Error', err.message, true);
          return;
        }
      } else {
        form.source = form.source.map((x) => x.value);
        // handle create campaign
        if (!form.is_bulk) form.segment_id = form.segment.id;

        if (form.is_bulk) {
          delete form.segment;
          delete form.segment_id;
        }

        // if image exist
        let bannerImageUrl = '';

        if (form.banner) {
          const request = new FormData();
          request.append('file', form.banner, form.banner.name);
          const res = await uploadFile(baseUrl, request, 'image');
          if (res?.status === STATUS_SUCCESS) {
            const { data } = res;
            bannerImageUrl = data.url;
          }
        }

        if (bannerImageUrl?.length > 0) form.banner_image_url = bannerImageUrl;

        if (isSelectAll) {
          let tmpStore = [];
          stores.forEach((el) => {
            tmpStore.push(el);
          });
          form.store = tmpStore;
        }

        const res = await createCampaign(baseUrl, form);
        setLoading(false);

        if (res?.status === STATUS_SUCCESS) {
          notif('Success', 'Campaign successfully created!');

          closeCreateEdit();

          setIsLoading(true);
          fetchCampaignList();
          return;
        }

        if (isSelectAll) {
          setForm({
            ...form,
            store: []
          });
        }

        if (res?.status === STATUS_UNAUTHORIZED) {
          localStorage.clear();
          navigate('/login', { replace: true });
          return;
        }

        const err = JSON.parse(await res.text());
        if (err) {
          notif('Error', err.message, true);
          return;
        }
      }

      notif('Error', 'Network error. Please try again later!', true);
    } catch (err) {
      setLoading(false);
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  // async function handleDeleteCampaign() {
  //   try {
  //     const baseUrl = process.env.REACT_APP_BASE_URL;

  //     const res = await deleteCampaign(baseUrl, form);

  //     if (res?.status === STATUS_SUCCESS) {
  //       notif('Success', 'Campaign successfully deleted!');

  //       closeDelete();

  //       setIsLoading(true);
  //       fetchCampaignList();
  //       return;
  //     }

  //     const err = JSON.parse(await res.text());
  //     if (err) {
  //       notif('Error', err.message, true);
  //       return;
  //     }

  //     notif('Error', 'Network error. Please try again later!', true);
  //   } catch (err) {
  //     notif('Error', 'Network error. Please try again later!', true);
  //   }
  // }

  async function handleDeleteNotification() {
    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;

      const res = await deleteNotificationCampaign(baseUrl, form.id);

      if (res?.status === STATUS_SUCCESS) {
        notif(
          'Success',
          'Notification from this Campaign successfully deleted!'
        );

        setShowDeleteNotification(false);
        setIsLoading(true);
        fetchCampaignList();
        return;
      }

      const err = JSON.parse(await res.text());
      if (err) {
        notif('Error', err.message, true);
        return;
      }

      notif('Error', 'Network error. Please try again later!', true);
    } catch (err) {
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  function isValidManualCampaign() {
    return (
      formManual.target_name?.length > 0 &&
      formManual.target_email?.length > 0 &&
      formManual.target_fcm_token?.length > 0 &&
      formManual.target_device_type?.length > 0 &&
      formManual.campaign_title?.length > 0 &&
      formManual.campaign_content?.length > 0 &&
      formManual.campaign_deeplink?.length > 0
    );
  }

  async function handleCreateManualCampaign() {
    if (!isValidManualCampaign()) {
      notif('Error', 'Please fill all required field', true);
      return;
    }

    const baseUrl = process.env.REACT_APP_BASE_URL;

    if (isFile && formManual.image) {
      // upload image first
      const formData = new FormData();
      formData.append('file', formManual.image, formManual.image.name);

      try {
        const res = await uploadFile(baseUrl, formData, 'image');

        if (res?.status === STATUS_SUCCESS) {
          const { data } = res;
          formManual.campaign_image_url = data.url;
        }

        if (res?.status === STATUS_UNAUTHORIZED) {
          localStorage.clear();
          navigate('/login', { replace: true });
          return;
        }

        const err = JSON.parse(await res.text());
        if (err) {
          notif('Error', err.message, true);
          return;
        }

        notif('Error', 'Network error. Please try again later', true);
      } catch (err) {
        notif('Error', 'Network error. Please try again later', true);
      }
    }

    if (isBannerFile && formManual.banner) {
      // upload image first
      const formData = new FormData();
      formData.append('file', formManual.banner, formManual.banner.name);

      try {
        const res = await uploadFile(baseUrl, formData, 'image');

        if (res?.status === STATUS_SUCCESS) {
          const { data } = res;
          formManual.campaign_banner_image_url = data.url;
        }

        if (res?.status === STATUS_UNAUTHORIZED) {
          localStorage.clear();
          navigate('/login', { replace: true });
          return;
        }

        const err = JSON.parse(await res.text());
        if (err) {
          notif('Error', err.message, true);
          return;
        }

        notif('Error', 'Network error. Please try again later', true);
      } catch (err) {
        notif('Error', 'Network error. Please try again later', true);
      }
    }

    try {
      const res = await createManualCampaign(baseUrl, formManual);

      if (res?.status === STATUS_SUCCESS) {
        notif('Success', 'Manual campaign successfully sent');
        closeManual();
        return;
      }

      if (res?.status === STATUS_UNAUTHORIZED) {
        localStorage.clear();
        navigate('/login', { replace: true });
        return;
      }

      const err = JSON.parse(await res.text());
      if (err) {
        notif('Error', err.message, true);
        return;
      }

      notif('Error', 'Network error. Please try again later', true);
    } catch (err) {
      notif('Error', 'Network error. Please try again later', true);
    }
  }

  const searchStoreListDebounce = useRef();

  return (
    <div>
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-row items-center gap-3">
          <h2 className="my-6 text-xl font-semibold text-gray-700 dark:text-gray-200">
            Campaign
          </h2>
          <MultiSelect
            data={PLATFORM_SOURCE}
            onChange={(value) =>
              setSource(value.map((item) => item.value).join(','))
            }
          />
        </div>
        <div className="flex flex-row">
          <button
            className="px-4 py-2 mt-3 mr-3 text-sm font-medium text-center bg-white border border-yellow-500 rounded-lg text-secondary leading-5 text-purple transition-colors duration-150 active:bg-yellow-600 hover:bg-yellow-100 focus:outline-none focus:shadow-outline-purple"
            onClick={handleManualCampaign}
          >
            Manual Campaign
          </button>
          <button
            className="px-4 py-2 mt-3 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150 bg-secondary hover:bg-yellow-700 focus:outline-none focus:shadow-outline-purple"
            onClick={() => handleCreateEdit(null)}
          >
            Add New
          </button>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={campaigns}
        sortServer
        onSort={handleSort}
        progressPending={isLoading}
        expandableRows
        expandableRowsComponent={CampaignDetail}
        pagination
        paginationServer
        paginationTotalRows={pagination.totalData}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
      />

      {/* Create Edit Section */}
      <Transition
        show={createEdit}
        enter="transition-all ease-in duration-100"
        enterFrom="opacity-0"
        enterTo="opacity-100"
      >
        <div className="fixed inset-0 z-20 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0">
              <div className="absolute inset-0 bg-gray-100 opacity-75"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
            <div
              className="relative inline-block px-8 pt-5 pb-8 overflow-hidden text-left align-bottom bg-white rounded-lg shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              {form.id ? (
                <h3 className="mb-3 font-bold">Edit Campaign</h3>
              ) : (
                <h3 className="mb-3 font-bold">Create Campaign</h3>
              )}

              <div
                className="absolute cursor-pointer top-3 right-3"
                onClick={closeCreateEdit}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>

              <label className="block text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Campaign For <span className="text-red-500">*</span>
                </span>
                {form.id ? (
                  <MultiSelect
                    data={PLATFORM_SOURCE}
                    onChange={(value) => {
                      setForm({ ...form, source: value });
                    }}
                    currentValue={form.source}
                  />
                ) : (
                  <MultiSelect
                    data={PLATFORM_SOURCE}
                    onChange={(value) => {
                      setForm({ ...form, source: value });
                    }}
                  />
                )}
              </label>

              <label className="block text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Name <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="12:12 Campaign"
                  name="name"
                  value={form.name}
                  onChange={handleChangeForm}
                />
              </label>
              {form.id == null ? (
                <label className="block mt-3 text-sm">
                  <div className="flex flex-col">
                    <span className="text-gray-700 dark:text-gray-400">
                      Bulk Notification
                    </span>
                    <span className="text-xs text-gray-400">
                      If enabled, it will send notification to all listed users
                    </span>
                  </div>
                  <div className="mt-2">
                    <Switch
                      checked={form.is_bulk}
                      onChange={handleChangeBulk}
                      className={`${
                        form.is_bulk ? 'bg-gray-500' : 'bg-gray-200'
                      } relative inline-flex flex-shrink-0 w-10 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                    >
                      <span className="sr-only">Bulk notifications</span>
                      <span
                        aria-hidden="true"
                        className={`${
                          form.is_bulk ? 'translate-x-5' : 'translate-x-0'
                        } pointer-events-none inline-block w-4 h-4 rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
                      />
                    </Switch>
                  </div>
                </label>
              ) : (
                <label className="block mt-3 text-sm">
                  <div className="flex flex-row items-center justify-between">
                    <span className="text-gray-700 dark:text-gray-400">
                      Notification Type
                    </span>
                  </div>
                  {form.is_bulk ? (
                    <span className={'text-gray-400'}>Bulk Notification</span>
                  ) : (
                    <span className={'text-gray-400'}>
                      Segmented Notification
                    </span>
                  )}
                  <div className="flex flex-row-reverse">
                    <span className="text-sm">{form.title?.length}/65</span>
                  </div>
                </label>
              )}
              {form.id ? null : form.is_bulk ? null : (
                <label className="block mt-3 text-sm">
                  <span className="text-gray-700 dark:text-gray-400">
                    Segment <span className="text-red-500">*</span>
                  </span>
                  <Autocomplete
                    arrData={segments}
                    initialValue={form.segment?.name || ''}
                    currentSegment={form.segment}
                    onChange={(segment) => {
                      if (segment != null) {
                        setForm({
                          ...form,
                          segment: segment,
                          is_notification: segment.is_notification
                        });
                      }
                    }}
                  />
                </label>
              )}
              <label className="block mt-3 text-sm">
                <div className="flex flex-row items-center justify-between">
                  <span className="text-gray-700 dark:text-gray-400">
                    Title <span className="text-red-500">*</span>
                  </span>
                  <span className="text-xs font-light text-gray-400">
                    Maximum length is 65 character
                  </span>
                </div>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="National Shopping Day Campaign"
                  name="title"
                  value={form.title}
                  onChange={handleChangeForm}
                />
                <div className="flex flex-row-reverse">
                  <span className="text-sm">{form.title?.length}/65</span>
                </div>
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Description <span className="text-red-500">*</span>
                </span>
                <textarea
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none h-28 rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="Donec faucibus felis facilisi potenti tempus sed dictumst."
                  name="description"
                  value={form.description}
                  onChange={handleChangeForm}
                />
                <div className="flex flex-row-reverse">
                  <span className="text-sm">
                    {form.description?.length}/125
                  </span>
                </div>
              </label>
              {form.id === STATUS_NULL ? (
                <label className="block mt-3 text-sm">
                  <div className="flex flex-col">
                    <span className="text-gray-700 dark:text-gray-400">
                      Include Notification
                    </span>
                    <span className="text-xs text-gray-400">
                      If enabled, it will send notification to the devices
                    </span>
                  </div>
                  <div className="mt-2">
                    <Switch
                      checked={form.is_notification}
                      onChange={handleChangeNotification}
                      disabled={!form.is_bulk && form.segment}
                      className={`${
                        form.is_notification ? 'bg-gray-500' : 'bg-gray-200'
                      }
          relative inline-flex flex-shrink-0 w-10 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                    >
                      <span className="sr-only">Enable notifications</span>
                      <span
                        aria-hidden="true"
                        className={`${
                          form.is_notification
                            ? 'translate-x-5'
                            : 'translate-x-0'
                        }
            pointer-events-none inline-block w-4 h-4 rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
                      />
                    </Switch>
                  </div>
                </label>
              ) : (
                <label className="block mt-3 text-sm">
                  <div className="flex flex-col">
                    <span className="text-gray-700 dark:text-gray-400">
                      Include Notification
                    </span>
                    <span className="text-xs text-gray-400">
                      If enabled, it will send notification to the devices
                    </span>
                  </div>
                  <div className="mt-2">
                    <Switch
                      checked={form.is_notification}
                      onChange={handleChangeNotification}
                      disabled={!form.is_bulk}
                      className={`${
                        form.is_notification ? 'bg-gray-500' : 'bg-gray-200'
                      }
          relative inline-flex flex-shrink-0 w-10 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                    >
                      <span className="sr-only">Enable notifications</span>
                      <span
                        aria-hidden="true"
                        className={`${
                          form.is_notification
                            ? 'translate-x-5'
                            : 'translate-x-0'
                        }
            pointer-events-none inline-block w-4 h-4 rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
                      />
                    </Switch>
                  </div>
                </label>
              )}
              <label className="block mt-3 text-sm">
                <div className="flex flex-col">
                  <span className="text-gray-700 dark:text-gray-400">
                    3 : 1 Image
                  </span>
                  <span className="text-xs text-gray-400">
                    Image with aspect ratio 3 : 1 (width : height)
                  </span>
                </div>
                {form.id && form.banner_image_url?.length > 0 ? (
                  <div className="mt-3 grid">
                    <img
                      src={form.banner_image_url}
                      className="object-cover w-32 h-16 rounded"
                    />
                  </div>
                ) : null}
                <input
                  readOnly
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="Upload Image"
                  type="file"
                  name="banner"
                  onChange={handleChangeForm}
                />
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Video URL
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="https://youtu.be/lIlGdZ6EQfg"
                  name="video_url"
                  value={form.video_url}
                  onChange={handleChangeForm}
                />
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Deeplink <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="test/campaign"
                  name="deeplink"
                  value={form.deeplink}
                  onChange={handleChangeForm}
                />
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Link <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="https://www.link-campaign.com"
                  name="link"
                  value={form.link}
                  onChange={handleChangeForm}
                />
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Valid From <span className="text-red-500">*</span>
                </span>

                <div className="relative">
                  <DatePicker
                    selected={form.valid_from}
                    name="valid_from"
                    dateFormat="dd MMMM yyyy HH:mm"
                    onChange={handleDateChange('valid_from')}
                    minDate={new Date()}
                    showTimeSelect
                    nextMonthButtonLabel={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    }
                    previousMonthButtonLabel={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 19l-7-7 7-7"
                        />
                      </svg>
                    }
                  />
                  <div className="absolute top-0 bottom-0 flex flex-col justify-center text-gray-400 cursor-pointer right-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                </div>
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Valid To <span className="text-red-500">*</span>
                </span>
                <div className="relative">
                  <DatePicker
                    selected={form.valid_to}
                    name="valid_to"
                    dateFormat="dd MMMM yyyy HH:mm"
                    onChange={handleDateChange('valid_to')}
                    minDate={new Date()}
                    showTimeSelect
                    nextMonthButtonLabel={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    }
                    previousMonthButtonLabel={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 19l-7-7 7-7"
                        />
                      </svg>
                    }
                  />
                  <div className="absolute top-0 bottom-0 flex flex-col justify-center text-gray-400 cursor-pointer right-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                </div>
              </label>
              <AutoCompleteMui
                multiple
                id="tags-filled"
                options={stores.map(
                  (option) => `${option.name}-${option.id}-${option.bu_code}`
                )}
                defaultValue={[]}
                disableCloseOnSelect
                freeSolo
                sx={{
                  '& input': {
                    display: 'block',
                    width: '100%',
                    bgcolor: 'background.paper',
                    paddingX: '.75rem',
                    paddingY: '.5rem',
                    marginTop: '.25rem',
                    fontSize: '.875rem',
                    lineHeight: '1.25rem',
                    borderWidth: 1,
                    appearance: 'none',
                    borderRadius: '.375rem',
                    color: (theme) =>
                      theme.palette.getContrastText(
                        theme.palette.background.paper
                      )
                  },
                  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
                    {
                      borderWidth: '1px',
                      borderColor: '#E4E7EB',
                      borderRadius: '5px'
                    }
                }}
                value={form.store.map(
                  (el) => `${el.name}-${el.id}-${el.bu_code}`
                )}
                onChange={handleChangeMuiAutoComplete}
                disabled={isSelectAll}
                renderOption={(props, option, { selected }) => {
                  const [name] = option.split('-');
                  return (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {name}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <div
                    ref={params.InputProps.ref}
                    className="block mt-3 text-sm"
                  >
                    <div className="flex flex-row items-center mb-2">
                      <div className="flex flex-col">
                        <span className="text-gray-700 dark:text-gray-400">
                          Store
                        </span>
                        <span className="text-xs text-gray-400">
                          For geofence campaign purpose
                        </span>
                      </div>
                      <div className="flex-1" />
                    </div>
                    <TextField
                      {...params}
                      hiddenLabel
                      onChange={({ target: { value } }) => {
                        if (searchStoreListDebounce.current) {
                          clearTimeout(searchStoreListDebounce.current);
                        }

                        searchStoreListDebounce.current = setTimeout(() => {
                          fetchStoreList(value);
                        }, 800);
                      }}
                      size="small"
                      sx={{
                        '& .MuiInputBase-root': {
                          '&:focus, &:hover': {
                            '& fieldset': {
                              borderWidth: '1px',
                              borderColor: '#E4E7EB'
                            }
                          },
                          '& fieldset': {
                            borderWidth: '1px',
                            borderColor: '#E4E7EB'
                          },
                          '& input': {
                            marginTop: '0 !important',
                            border: 'none',
                            outline: 'none'
                          }
                        }
                      }}
                    />
                  </div>
                )}
              />
              <div className="flex flex-row-reverse">
                <button
                  className="flex flex-row px-4 py-2 mt-3 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150 bg-secondary hover:bg-yellow-700 focus:outline-none focus:shadow-outline-purple"
                  onClick={handleCreateEditCampaign}
                >
                  {loading ? <Loading /> : null}
                  {form.id ? 'Edit' : 'Create'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Transition>

      {/* Manual Campaign section */}
      <Transition
        show={showManual}
        enter="transition-all ease-in duration-100"
        enterFrom="opacity-0"
        enterTo="opacity-100"
      >
        <div className="fixed inset-0 z-20 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0">
              <div className="absolute inset-0 bg-gray-100 opacity-75"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
            <div
              className="relative inline-block px-8 pt-5 pb-8 overflow-hidden text-left align-bottom bg-white rounded-lg shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <div
                className="absolute cursor-pointer top-3 right-3"
                onClick={closeManual}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h3 className="mb-3 font-bold">Create Manual Campaign</h3>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Target Name <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="John Doe"
                  name="target_name"
                  value={formManual.target_name}
                  onChange={handleChangeFormManual}
                />
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Target Email <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="john@doe.com"
                  name="target_email"
                  value={formManual.target_email}
                  onChange={handleChangeFormManual}
                />
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Target Device Type <span className="text-red-500">*</span>
                </span>
                <Listbox
                  value={formManual.target_device_type}
                  onChange={handleDeviceTypeChange}
                >
                  <div className="relative mt-1">
                    <Listbox.Button className="relative w-full py-2 pl-3 pr-10 text-left bg-white border rounded-lg cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm">
                      <span className="block truncate">
                        {formManual.target_device_type}
                      </span>
                      <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-5 h-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                          />
                        </svg>
                      </span>
                    </Listbox.Button>
                    <Transition
                      as={Fragment}
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white shadow-lg rounded-md max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                        {DEVICE_TYPE.map((device, index) => (
                          <Listbox.Option
                            key={index}
                            className={({ active }) =>
                              `${
                                active
                                  ? 'text-amber-900 bg-amber-100'
                                  : 'text-gray-900'
                              }
                          cursor-default select-none relative py-2 pl-10 pr-4`
                            }
                            value={device}
                          >
                            {({ selected, active }) => (
                              <>
                                <span
                                  className={`${
                                    selected ? 'font-medium' : 'font-normal'
                                  } block truncate`}
                                >
                                  {device}
                                </span>
                                {selected ? (
                                  <span
                                    className={`${
                                      active
                                        ? 'text-amber-600'
                                        : 'text-amber-600'
                                    }
                                absolute inset-y-0 left-0 flex items-center pl-3`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="w-5 h-5"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                      />
                                    </svg>
                                  </span>
                                ) : null}
                              </>
                            )}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </Transition>
                  </div>
                </Listbox>
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Target FCM Token <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  name="target_fcm_token"
                  value={formManual.target_fcm_token}
                  onChange={handleChangeFormManual}
                />
              </label>
              <label className="block mt-3 text-sm">
                <div className="flex flex-row items-center justify-between">
                  <span className="text-gray-700 dark:text-gray-400">
                    Campaign Title <span className="text-red-500">*</span>
                  </span>
                  <span className="text-xs font-light text-gray-400">
                    Maximum length is 65 character
                  </span>
                </div>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  name="campaign_title"
                  value={formManual.campaign_title}
                  onChange={handleChangeFormManual}
                />
                <div className="flex flex-row-reverse">
                  <span className="text-sm">
                    {formManual.campaign_title?.length}/65
                  </span>
                </div>
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Campaign Description
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  name="campaign_description"
                  value={formManual.campaign_description}
                  onChange={handleChangeFormManual}
                />
              </label>
              <label className="block mt-3 text-sm">
                <div className="flex flex-row items-center justify-between">
                  <span className="text-gray-700 dark:text-gray-400">
                    Campaign Content <span className="text-red-500">*</span>
                  </span>
                  <span className="text-xs font-light text-gray-400">
                    Maximum length is 200 character
                  </span>
                </div>
                <textarea
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  name="campaign_content"
                  value={formManual.campaign_content}
                  onChange={handleChangeFormManual}
                ></textarea>
                <div className="flex flex-row-reverse">
                  <span className="text-sm">
                    {formManual.campaign_content?.length}/200
                  </span>
                </div>
              </label>
              <label className="block mt-3 text-sm">
                <div className="flex flex-row items-center">
                  <div className="flex flex-col">
                    <span className="text-gray-700 dark:text-gray-400">
                      Campaign Image
                    </span>
                    <span className="text-xs text-gray-400">
                      Image with aspect ratio 1 : 1
                    </span>
                  </div>
                  <div className="flex-1" />
                  <div className="flex flex-row items-center">
                    <span className="mr-3 text-sm text-gray-400">
                      Pick file or input image url
                    </span>
                    <Switch
                      checked={isFile}
                      onChange={handleChangeIsFile}
                      className={`${isFile ? 'bg-gray-500' : 'bg-gray-200'}
          relative inline-flex flex-shrink-0 w-10 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                    >
                      <span className="sr-only">File or Image URL</span>
                      <span
                        aria-hidden="true"
                        className={`${
                          isFile ? 'translate-x-5' : 'translate-x-0'
                        }
            pointer-events-none inline-block w-4 h-4 rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
                      />
                    </Switch>
                  </div>
                </div>
                {isFile ? (
                  <input
                    readOnly
                    className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                    placeholder="Upload Image"
                    type="file"
                    name="image"
                    onChange={handleChangeFormManual}
                  />
                ) : (
                  <input
                    className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                    name="campaign_image_url"
                    value={formManual.campaign_image_url}
                    onChange={handleChangeFormManual}
                  />
                )}
              </label>
              <label className="block mt-3 text-sm">
                <div className="flex flex-row items-center">
                  <div className="flex flex-col">
                    <span className="text-gray-700 dark:text-gray-400">
                      Campaign Image 2:1
                    </span>
                    <span className="text-xs text-gray-400">
                      Image with aspect ratio 2 : 1
                    </span>
                  </div>
                  <div className="flex-1" />
                  <div className="flex flex-row items-center">
                    <span className="mr-3 text-sm text-gray-400">
                      Pick file or input image url
                    </span>
                    <Switch
                      checked={isBannerFile}
                      onChange={handleChangeIsBannerFile}
                      className={`${
                        isBannerFile ? 'bg-gray-500' : 'bg-gray-200'
                      }
          relative inline-flex flex-shrink-0 w-10 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                    >
                      <span className="sr-only">File or Image URL</span>
                      <span
                        aria-hidden="true"
                        className={`${
                          isBannerFile ? 'translate-x-5' : 'translate-x-0'
                        }
            pointer-events-none inline-block w-4 h-4 rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
                      />
                    </Switch>
                  </div>
                </div>
                {isBannerFile ? (
                  <input
                    readOnly
                    className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                    placeholder="Upload Image"
                    type="file"
                    name="banner"
                    onChange={handleChangeFormManual}
                  />
                ) : (
                  <input
                    className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                    name="campaign_image_url"
                    value={formManual.campaign_banner_image_url}
                    onChange={handleChangeFormManual}
                  />
                )}
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Campaign Video URL
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  name="campaign_video_url"
                  value={formManual.campaign_video_url}
                  onChange={handleChangeFormManual}
                />
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Campaign Deeplink <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  name="campaign_deeplink"
                  value={formManual.campaign_deeplink}
                  onChange={handleChangeFormManual}
                />
              </label>
              <div className="flex flex-row-reverse">
                <button
                  className="px-4 py-2 mt-3 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150 bg-secondary hover:bg-yellow-700 focus:outline-none focus:shadow-outline-purple"
                  onClick={handleCreateManualCampaign}
                >
                  Send Manual Campaign
                </button>
              </div>
            </div>
          </div>
        </div>
      </Transition>

      {/* Delete Section */}
      {/* <Transition
        show={showDelete}
        enter="transition-all ease-in duration-100"
        enterFrom="opacity-0"
        enterTo="opacity-100"
      >
        <div className="fixed inset-0 z-20 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0">
              <div className="absolute inset-0 bg-gray-100 opacity-75"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
            <div
              className="inline-block p-8 overflow-hidden text-left align-bottom bg-white rounded-lg shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <h3 className="font-bold">Delete Confirmation</h3>
              <div
                className="absolute cursor-pointer top-3 right-3"
                onClick={closeDelete}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <p>Are you sure to delete this item?</p>
              <div className="flex flex-row-reverse">
                <button
                  className="px-4 py-2 mt-3 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150 bg-secondary hover:bg-yellow-700 focus:outline-none focus:shadow-outline-purple"
                  onClick={closeDelete}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 mt-3 text-sm font-medium text-center border border-transparent rounded-lg leading-5 transition-colors duration-150 focus:outline-none focus:shadow-outline-purple"
                  onClick={handleDeleteCampaign}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </Transition> */}

      {/* Delete Notification Section */}
      <Transition
        show={showDeleteNotification}
        enter="transition-all ease-in duration-100"
        enterFrom="opacity-0"
        enterTo="opacity-100"
      >
        <div className="fixed inset-0 z-20 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0">
              <div className="absolute inset-0 bg-gray-100 opacity-75"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
            <div
              className="inline-block p-8 overflow-hidden text-left align-bottom bg-white rounded-lg shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <h3 className="font-bold">Delete Confirmation</h3>
              <div
                className="absolute cursor-pointer top-3 right-3"
                onClick={() => setShowDeleteNotification(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <p>Are you sure to delete notification from this campaign?</p>
              <div className="flex flex-row-reverse">
                <button
                  className="px-4 py-2 mt-3 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150 bg-secondary hover:bg-yellow-700 focus:outline-none focus:shadow-outline-purple"
                  onClick={() => setShowDeleteNotification(false)}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 mt-3 text-sm font-medium text-center border border-transparent rounded-lg leading-5 transition-colors duration-150 focus:outline-none focus:shadow-outline-purple"
                  onClick={handleDeleteNotification}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </Transition>

      {/* Detail Section */}
      <Transition
        show={showDetail}
        enter="transition-all ease-in duration-100"
        enterFrom="opacity-0"
        enterTo="opacity-100"
      >
        <div className="fixed inset-0 z-20 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0">
              <div className="absolute inset-0 bg-gray-100 opacity-75"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
            <div
              className="inline-block p-8 overflow-hidden text-left align-bottom bg-white rounded-lg shadow-xl transform transition-all sm:my-8 sm:align-middle min-w-[90vw]"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <div
                className="absolute cursor-pointer top-3 right-3"
                onClick={closeDetailCampaignSummary}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>

              {/* Header */}
              <div className="flex justify-between items-center mt-5">
                <div>
                  <h1 className="text-xl font-bold">Campaign Summary</h1>
                  <p>Campaign Information</p>
                </div>
                <div className="flex items-center gap-2 text-gray-500 text-sm">
                  <span>UPDATED AT: {detailSummary?.updated_at}</span>
                </div>
              </div>

              {/* Summary Boxes */}
              <div className="grid grid-cols-2 gap-4 mt-6">
                {/* Inbox Notification Summary */}
                <div>
                  <div className="font-bold mb-2">
                    Summary of Inbox Notification
                  </div>
                  <div className="grid grid-cols-2 gap-4 bg-orange-100 p-4 rounded-lg">
                    <div className="flex flex-col items-center bg-orange-300 rounded p-4">
                      <MarkEmailReadIcon
                        className="text-orange-500"
                        fontSize="large"
                      />
                      <span className="text-sm font-bold mt-3">
                        Delivered to Inbox
                      </span>
                      <span className="text-2xl font-bold">
                        {detailSummary?.delivered_to_inbox}
                      </span>
                    </div>
                    <div className="flex flex-col items-center bg-orange-300 rounded p-4">
                      <DraftsIcon
                        className="text-orange-500"
                        fontSize="large"
                      />
                      <span className="text-sm font-bold mt-3">
                        Open on Inbox
                      </span>
                      <span className="text-2xl font-bold">
                        {detailSummary?.open_on_inbox}
                      </span>
                    </div>
                    <div className="flex flex-col items-center bg-orange-300 rounded p-4">
                      <SendIcon className="text-orange-500" fontSize="large" />
                      <span className="text-sm font-bold mt-3">
                        Open rate %
                      </span>
                      <span className="text-2xl font-bold">
                        {detailSummary?.open_rate}
                      </span>
                    </div>
                    <div className="flex flex-col items-center bg-orange-300 rounded p-4">
                      <CancelScheduleSendIcon
                        className="text-orange-500"
                        fontSize="large"
                      />
                      <span className="text-sm font-bold mt-3">
                        Failed send to Inbox
                      </span>
                      <span className="text-2xl font-bold">
                        {detailSummary?.failed_send_to_inbox}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Push Notification Summary */}
                <div>
                  <div className="font-bold mb-2">
                    Summary of Push Notification
                  </div>
                  <div className="grid grid-cols-2 gap-4 bg-blue-100 p-4 rounded-lg">
                    <div className="flex flex-col items-center justify-center bg-cyan-300 rounded p-4">
                      <NotificationsActiveIcon
                        className="text-blue-500"
                        fontSize="large"
                      />
                      <span className="text-sm font-bold mt-3">
                        Push Notification Sent
                      </span>
                      <span className="text-2xl font-bold">
                        {detailSummary?.push_notification_send}
                      </span>
                    </div>
                    <div className="flex flex-col items-center justify-center bg-cyan-300 rounded p-4">
                      <NotificationsOffIcon
                        className="text-blue-500"
                        fontSize="large"
                      />
                      <span className="text-sm font-bold mt-3">
                        Failed to Send Push Notification
                      </span>
                      <span className="text-2xl font-bold">
                        {detailSummary?.push_notification_failed_send}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Campaign Details */}
              <div className="grid grid-rows-2 grid-cols-12 gap-4 mt-6 bg-blue-950 text-white p-4 rounded-lg">
                <div className="col-span-3 bg-blue-800 rounded pt-4 pb-14 px-7">
                  <h2 className="text-md font-bold text-white">Campaign ID</h2>
                  <p className="text-xl text-orange-400 font-bold">
                    {detailSummary?.capaign_id}
                  </p>
                </div>
                <div className="col-span-3 bg-blue-800 rounded pt-4 pb-14 px-7">
                  <h2 className="text-md font-bold">Campaign Name</h2>
                  <p className="text-xl text-orange-400 font-bold">
                    {detailSummary?.campaign_name}
                  </p>
                </div>
                <div className="col-span-3 bg-blue-800 rounded pt-4 pb-14 px-7">
                  <h2 className="text-md font-bold">Sender Name</h2>
                  <p className="text-xl text-orange-400 font-bold">
                    {detailSummary?.sender_name}
                  </p>
                </div>
                <div className="col-span-3 bg-blue-800 rounded pt-4 pb-14 px-7">
                  <h2 className="text-md font-bold">Campaign Target</h2>
                  <p className="text-xl text-orange-400 font-bold">
                    {detailSummary?.campaign_target}
                  </p>
                </div>
                <div className="col-span-4 bg-blue-800 rounded pt-4 pb-14 px-7">
                  <h2 className="text-md font-bold">Status</h2>
                  <p className="text-xl text-orange-400 font-bold">
                    {detailSummary?.status}
                  </p>
                </div>
                <div className="col-span-4 bg-blue-800 rounded pt-4 pb-14 px-7">
                  <h2 className="text-md font-bold">Valid From</h2>
                  <p className="text-xl text-orange-400 font-bold">
                    {detailSummary?.valid_from}
                  </p>
                </div>
                <div className="col-span-4 bg-blue-800 rounded pt-4 pb-14 px-7">
                  <h2 className="text-md font-bold">Valid To</h2>
                  <p className="text-xl text-orange-400 font-bold">
                    {detailSummary?.valid_to}
                  </p>
                </div>
              </div>

              {/* Export Buttons */}
              <div className="flex justify-center gap-4 mt-6">
                <Button
                  variant="contained"
                  className="!bg-orange-400 hover:!bg-orange-700 !font-bold !text-black"
                  onClick={() => {
                    window.open(detailSummary?.tracker_url, '_blank');
                  }}
                >
                  Export Campaign Tracker
                </Button>
                <Button
                  variant="contained"
                  className="bg-purple-600 hover:bg-purple-700 !font-bold"
                  onClick={() => {
                    window.open(detailSummary?.summary_url, '_blank');
                  }}
                >
                  Export Campaign Summary
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Transition>

      <Notification
        notification={notification}
        closeNotification={closeNotification}
      />
    </div>
  );
}
